import { Navigate, Outlet } from 'react-router-dom';

const UserRoute = () => {
  const token = localStorage.getItem('slm-token');
  return token ? <Outlet /> : <Navigate to='/' />;
};
export default UserRoute;
